import type React from 'react';
import { Helmet } from 'react-helmet-async';

import { sanitizeUrl } from '@xing-com/crate-people-directory-utils';

import {
  DEFAULT_APPLE_ICON,
  DEFAULT_ICON,
  DEFAULT_SEO_IMAGE,
} from './constants';

type MetaDataProps = {
  title?: string;
  description?: string;
  url: string;
  image?: string;
  index?: boolean;
};

export const MetaData: React.FC<MetaDataProps> = ({
  title,
  url,
  image,
  description,
  index = false,
}) => {
  const robotsContent = index ? 'index, follow' : 'noindex, follow';
  const seoImage = image || DEFAULT_SEO_IMAGE;

  const formattedUrl = sanitizeUrl(url);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="robots" content={robotsContent} />
      <meta name="description" content={description} />
      <meta name="referrer" content="default" />
      <meta name="robots" content="noarchive" />
      <meta name="robots" content="noodp" />
      <meta
        name="viewport"
        content="width=device-width, minimum-scale=1, maximum-scale=1, user-scalable=0"
      />
      <link rel="canonical" href={formattedUrl} />
      <link rel="shortcut icon" href={DEFAULT_ICON} type="image/ico" />
      <link rel="apple-touch-icon" href={DEFAULT_APPLE_ICON} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@XING_de" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={seoImage} />

      {/* OG tags */}
      <meta property="og:title" content={title} />
      <meta property="og:url" content={formattedUrl} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="XING" />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};
